import { render } from "./services2.vue?vue&type=template&id=2caa3672"
import script from "./services2.vue?vue&type=script&lang=js"
export * from "./services2.vue?vue&type=script&lang=js"

import "./services2.vue?vue&type=style&index=0&id=2caa3672&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__